import React from 'react';

import TopNavBarCart from './TopNavBarCart';
import TrustedElements from '../../core/components/TrustedElements';

const CartStep = ({ title, onGoPrevClick, children }) => (
    <>
        <TopNavBarCart title={title} onGoPrevClick={onGoPrevClick}/>
        {children}
        <TrustedElements />
    </>
);
export default CartStep;
